import { render, staticRenderFns } from "./SortingRecord.vue?vue&type=template&id=7bb8a2e0&scoped=true"
import script from "./SortingRecord.vue?vue&type=script&lang=js"
export * from "./SortingRecord.vue?vue&type=script&lang=js"
import style0 from "./SortingRecord.vue?vue&type=style&index=0&id=7bb8a2e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8a2e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb8a2e0')) {
      api.createRecord('7bb8a2e0', component.options)
    } else {
      api.reload('7bb8a2e0', component.options)
    }
    module.hot.accept("./SortingRecord.vue?vue&type=template&id=7bb8a2e0&scoped=true", function () {
      api.rerender('7bb8a2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sorting/SortingRecord.vue"
export default component.exports